import React from "react";
import { Plus } from "lucide-react";
import styles from "./Home.module.css";

/*
 * A titled, horizontally-scrollable row of event cards. Extracted from
 * HomeScreen.jsx, which used to render this exact markup twice (once for
 * "first row" events, once for "second row" events) with nothing different
 * but the data and title.
 */
export default function EventRow({
  title,
  events,
  joinedEvents = [],
  onSelectEvent,
  onToggleJoinEvent,
}) {
  if (!events || events.length === 0) return null;

  return (
    <div className={styles.sectionGroup}>
      <h2 className={styles.sectionHeading}>{title}</h2>

      <div className={styles.horizontalScrollContainer}>
        {events.map((ev) => {
          const isJoined = joinedEvents.includes(ev.id);
          return (
            <div
              key={ev.id}
              onClick={() => onSelectEvent(ev)}
              className={styles.horizontalCard}
            >
              <div className={styles.horizontalCardHeader}>
                <div className={styles.horizontalCardThumbWrapper}>
                  <img
                    src={ev.image}
                    alt={ev.title}
                    className={styles.avatarImg}
                  />
                </div>
                <div className={styles.horizontalCardInfo}>
                  <h4 className={styles.horizontalCardTitle}>{ev.title}</h4>
                  <p className={styles.horizontalCardHost}>
                    Hosted by: {ev.host}
                  </p>
                  <p className={styles.horizontalCardDate}>{ev.date}</p>
                </div>
              </div>

              <p className={styles.horizontalCardDesc}>
                {ev.description || ev.desc}
              </p>

              <div className={styles.horizontalCardFooter}>
                <span className={styles.horizontalCardCategory}>
                  {ev.category || "Activity"}
                </span>
                <div className={styles.horizontalCardActions}>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      if (onToggleJoinEvent) onToggleJoinEvent(ev.id);
                    }}
                    className={styles.horizontalCardPlusBtn}
                    title="Join Event"
                  >
                    <Plus size={14} />
                  </button>
                  <span className={styles.horizontalCardBadge}>
                    {isJoined ? "Joined" : "See more"}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
